import { Role } from '@ekkogmbh/apisdk';
import { ListItemText } from '@mui/material';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  role?: Role;
  onChange: (role?: Role) => void;
  disabled?: boolean;
}

export default function RolePicker({ role, disabled, onChange }: Props): React.JSX.Element {
  const { api } = useEkko();

  return (
    <PaginatedSelect
      label={'Role'}
      value={role}
      disabled={disabled}
      onChange={(r) => onChange(r as Role | undefined)}
      itemId={(r) => r.name}
      itemRender={(r) => <ListItemText primary={r.name} secondary={r.coordinate} />}
      fetchPaginatedItems={async (pagination) => api.getRoles(pagination)}
    />
  );
}
